import { html, css } from 'lit-element';
import { debounce } from 'throttle-debounce';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import { TmnTableSimple } from './tmn-table-simple';

export class TmnTableSearchable extends TmnTableSimple {
    constructor() {
        super();
        this._handleSearchStringChanged = debounce(250, this._handleSearchStringChanged);
        this.searchString = '';
        this.useFilters = true;
        this.useSearch = true;
    }

    static get styles() {
        // can be shared with site or more general table component maybe?
        return [
            ...super.styles,
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    /* max-width: 1200px; */
                    /* --table-cell-height: 37px; */
                }
                tmn-input[name='search'] {
                    margin: 0;
                    /* this is a hack, need to sort out the top bar css better */
                    /* margin-right: 10px; */
                }
                .main-panel {
                    display: flex;
                    flex-flow: column;
                    height: 100%;
                }
                .main-panel > .scroller {
                    /* overflow-y: auto;
                    overflow-x: hidden; */
                    overflow: auto;
                    padding: 0 8px;
                }

                .scroller::-webkit-scrollbar {
                    width: 10px;
                }

                .scroller::-webkit-scrollbar-track {
                    border-radius: 8px;
                    background-color: #e7e7e7;
                    border: 1px solid #cacaca;
                }

                .scroller::-webkit-scrollbar-thumb {
                    border-radius: 8px;
                    background-color: var(--app-secondary-dark-color);
                }

                .top-bar {
                    display: flex;
                    align-items: center;
                    flex-direction: row;
                    /* margin-top: 4px; */
                    /* padding: 8px 10px; */
                    min-height: 54px;
                    max-width: var(--tmn-table-simple-max-bar-width, 1200px);
                }
                .top-bar > * {
                    display: flex;
                    align-items: center;
                }
                /* .top-bar .left {
                } */
                .top-bar .primary {
                    flex: 1;
                    padding-left: 6px;
                    padding-right: 8px;
                }
                /* .top-bar .right {
                } */
                .top-bar .message {
                    min-height: 36px;
                }
                .top-bar tmn-input {
                    flex: 1;
                }
                .filter-panel {
                    display: flex;
                    flex-flow: column;
                    border: 1px solid #d0cfcf;
                    background-color: white;
                    border-radius: 8px;
                    padding: 10px;
                    margin-right: 10px;
                    min-width: 250px;
                }
                /* .top-bar > tmn-grid {
                    min-height: 38px;
                }
                .top-bar > tmn-grid > tmn-grid:last-child {
                    flex-basis: auto;
                    width: 150px;
                } */
                .filter-select-btn > div {
                    display: flex;
                    justify-content: space-between;
                    width: 180px;
                    align-items: center;
                }
                .filter-panel .header {
                    font-weight: 600;
                    font-size: 1.1rem;
                    padding: 8px 4px;
                    display: flex;
                    align-items: center;
                }
                .filter-panel > * {
                    border-bottom: 1px solid #d0cfcf;
                }
                .filter-panel > tmn-button {
                    min-height: 52px;
                }
                .filter-panel tmn-checkbox {
                    min-height: 52px;
                    width: unset;
                    height: unset;
                    margin-left: 20px;
                    width: calc(100% - 14px);
                }
                .filter-remover > .dot {
                    display: inline-flex;
                    height: 9px;
                    width: 9px;
                    min-width: 9px;
                    /* color: var(--app-on-primary-color); */
                    background: var(--app-primary-color);
                    border-radius: 50%;
                }
                .filter-remover:hover > .dot {
                    display: none;
                }
                .filter-remover > tmn-icon-button {
                    display: none;
                    width: 24px;
                    min-width: 24px;
                }
                .filter-remover:hover > tmn-icon-button {
                    display: inline-flex;
                }

                .filter-remover {
                    height: 24px;
                    width: 24px;
                    --tmn-icon-width: 22px;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                }
            `,
        ];
    }

    static get properties() {
        return {
            searchString: {
                type: String,
            },
            showFilterPanel: {
                type: Boolean,
            },
            useFilters: {
                type: Boolean,
            },
            selectedFilterDefPath: {
                type: String,
            },
            useSearch: {
                type: Boolean,
            },
            useExternalSearch: {
                type: Boolean,
            },
        };
    }

    renderPrimaryTopActions() {
        const { searchString, useSearch } = this;
        if (!useSearch) {
            return;
        }
        return html`<tmn-input
            name="search"
            .value=${searchString}
            placeholder="Search"
            @tmn-input-changed=${this._handleSearchStringChanged}></tmn-input>`;
    }

    _handleSearchStringChanged(e) {
        const { value } = e.detail;
        this.searchString = value;
        this._fireSearchEvent(e, { search: value });
    }

    _fireSearchEvent(e, data = {}) {
        this._fireEvent(e, 'tmn-table-search-changed', data);
    }

    _fireEvent(e, eventName, data = {}) {
        const event = new CustomEvent(eventName, {
            detail: { originalEvent: e, ...data },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }

    getRows() {
        const baseRows = super.getRows();
        if (this.useExternalSearch) {
            return baseRows;
        }
        const { searchString } = this;
        if (!searchString) {
            return baseRows;
        }
        // todo, possibly to make this faster
        const columnDefs = this.getColumnDefs();
        const colIndicesToSearch = columnDefs
            .map((def, idx) => ({ idx, search: def.search }))
            .filter((o) => o.search)
            .map((o) => o.idx);
        const matchSearchString = searchString.toLowerCase();
        const searchRowFilter = (row) => {
            // simple for now, do any of our searchable columns match
            return colIndicesToSearch.some((colIndex) => {
                const colData = row?.data[colIndex];
                if (colData) {
                    const searchData = Array.isArray(colData) ? colData.join(' ') : colData;
                    return searchData.toLowerCase().includes(matchSearchString);
                }
            });
        };

        return baseRows.filter(searchRowFilter);
    }

    render() {
        return html`${this.renderTopBar()}
            <div class="main-panel">${this.renderFilterPanel()}${this.renderTable()}</div>`;
    }

    renderTopBar() {
        // show multiselect is just a temp option to turn this off
        // TODO the "filters" section should really be baked into the columns of the table, for now just
        // quick and dirty to be able to filter inactives
        return html`<div class="top-bar">
            <div class="left">${this.renderLeftTopActions()}</div>
            <div class="primary">${this.renderPrimaryTopActions()}</div>
            <div class="right">${this.renderRightTopActions()}</div>
        </div>`;
    }

    renderFilterButton() {
        if (this.useFilters) {
            return html`
                <tmn-icon-button @click=${this.toggleFilterPanel}>
                    <tmn-icon icon="filter_alt" iconvariant="outlined" color="primary"></tmn-icon>
                </tmn-icon-button>
            `;
        }
    }

    toggleFilterPanel(e) {
        this.showFilterPanel = !this.showFilterPanel;
    }

    renderFilterPanel() {
        const { showFilterPanel, filterDefs, selectedFilterDefPath } = this;
        if (showFilterPanel) {
            return html`<div class="filter-panel">
                ${selectedFilterDefPath
                    ? this.renderSelectedFilter()
                    : html`<div class="header">Filters</div>
                          ${this.renderFilters()}`}
            </div>`;
        }
    }

    renderFilters() {
        const { showFilterPanel, filterDefs } = this;
        if (!filterDefs?.length) {
            return null;
        }

        //.justifyContent=${'flex-start'}
        return filterDefs.map((def) => {
            return html`<tmn-button
                @click=${this.handleShowFilter}
                variant="text"
                class="filter-select-btn"
                .endIconEnabled=${true}
                .eventData=${{ path: def.path }}
                .justifyContent=${'flex-start'}>
                <div>${def.label} ${this.renderHasFilter(def)}</div>
                <tmn-icon slot="endIcon" icon="arrow_right"></tmn-icon>
            </tmn-button>`;
        });
    }
    //${this.renderHasFilter(def)}
    //<tmn-icon icon="circle" color="primary"></tmn-icon>
    renderHasFilter(filterDef) {
        if (filterDef.hasSelectedValue()) {
            return html`<div class="filter-remover">
                <div class="dot"></div>
                <tmn-icon-button @click=${(e) => this.clearFilterDefValues(e, filterDef)}>
                    <tmn-icon icon="delete" iconvariant="outlined" color="primary"></tmn-icon>
                </tmn-icon-button>
            </div>`;
        }
    }

    clearFilterDefValues(e, filterDef) {
        if (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
        }
        // filterDef.clearSelectedData();
        //const newSelectedValues = selectedFilterDef.toggleOption(optionName, checked);
        let v;
        this.dispatchFilterChanged(filterDef.path, v);
    }

    getSelectedFilterDef() {
        const { selectedFilterDefPath, filterDefs } = this;
        const selectedFilterDef = filterDefs.find((d) => d.path === selectedFilterDefPath);
        return selectedFilterDef;
    }

    renderSelectedFilter() {
        const selectedFilterDef = this.getSelectedFilterDef();
        // todo by type here.... //maybe switch by type
        return html`<div class="header">
                <tmn-icon-button @click=${this.handleUnselectFilter}>
                    <tmn-icon icon="arrow_back"></tmn-icon>
                </tmn-icon-button>
                ${selectedFilterDef.label}
            </div>

            ${selectedFilterDef.getOptionsWithValues().map((option) => {
                return html`<div>
                    <tmn-checkbox
                        label=${option.displayKey}
                        .checked=${option.checked}
                        .value=${option.name}
                        @tmn-switch-change=${this.handleToggleFilterValue}
                        >${option.displayKey}
                    </tmn-checkbox>
                </div> `;
            })} `;
    }

    handleToggleFilterValue(e) {
        const selectedFilterDef = this.getSelectedFilterDef();
        const { value: optionName, checked } = e.detail;
        const newSelectedValues = selectedFilterDef.toggleOption(optionName, checked);
        this.dispatchFilterChanged(selectedFilterDef.path, newSelectedValues);
    }

    dispatchFilterChanged(path, selectedValues) {
        const event = new CustomEvent('tmn-table-selected-filter-data-changed', {
            detail: {
                path,
                selectedValues,
            },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }

    handleShowFilter(e) {
        this.selectedFilterDefPath = e.detail.path;
    }
    handleUnselectFilter(e) {
        this.selectedFilterDefPath = null;
    }

    renderLeftTopActions() {
        return html`${this.renderFilterButton()}<slot name="left-actions"></slot>`;
    }

    renderRightTopActions() {
        return html`<slot name="right-actions"></slot>`;
    }
}

window.customElements.define('tmn-table-searchable', TmnTableSearchable);
